import { render, staticRenderFns } from "./CompanyBalance.vue?vue&type=template&id=3fd1edf4&"
import script from "./CompanyBalance.vue?vue&type=script&lang=js&"
export * from "./CompanyBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports